import { createSlice } from "@reduxjs/toolkit";
import { PartnerLogsType } from "./Types";

type initialStateType = {
  partnerLogs: PartnerLogsType[];
  status: {
    partnerLogsLoading: boolean;
  };
}

const initialState: initialStateType = {
  partnerLogs: [],
  status: {
    partnerLogsLoading: false,
  }
};

const partnerLogsSlice = createSlice({
  name: "partner_logs",
  initialState: initialState,
  reducers: {
    setPartnerLogs: (state, action) => {
      state.partnerLogs = action.payload;
    },
    setPartnerLogsLoading: (state, action) => {
      state.status.partnerLogsLoading = action.payload;
    },
  },
});

export const partnerLogsSliceReducer = partnerLogsSlice.reducer;
export const partnerLogsSliceAction = partnerLogsSlice.actions;
